import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import EventList from '../components/events/EventList'
import EventsSkeleton from '../components/events/EventsSkeleton'
import { useEvents } from '../hooks/useEvents'

const EventsTab: FC = () => {
	const { t } = useTranslation('pages_saving')
	const eventsHook = useEvents()

	return (
		<>
			<EventsSkeleton display={eventsHook.isInitialLoading} />

			<EventList eventsHook={eventsHook} t={t} />
		</>
	)
}

export default EventsTab
